<script>
    import hosted from '../private/hosted';

    /**
     * This is a dialog view that can be modeless or modal, and is free standing (not anchored
     * to an element or the window). Dialogs may be used inline in a template, but are rendered
     * out of place to prevent clipping. It is recommended that you encapsulate your dialog
     * content in a component of its own. A `buttons` slot is provided; this slot renders
     * `ib-button` controls with platform dependent dialog styling.
     */
    export default {
        name: 'ib-dialog',

        mixins: [
            hosted
        ],

        inheritAttrs: false,

        props: {
            /**
             * If `true`, this is a modeless dialog, and will not block interaction with other
             * user interface elements.
             */
            modeless: Boolean,
            /**
             * Width in any CSS units.
             */
            width: String,
            /**
             * Height in any CSS units.
             */
            height: String,
            /**
             * If `true`, close this dialog when clicking anywhere outside of it.
             */
            autoclose: Boolean
        },

        data() {
            return {
                visible: false,
                key: 0
            };
        },

        render(h) {
            // empty
        },

        updated() {
            this.key++;
        },

        methods: {
            show() {
                this.visible = true;
            },

            hide() {
                this.visible = false;
            },

            renderSelf(h) {
                // Pass reactivity
                void this.key;

                const modal = !this.modeless;
                return h('transition', {
                    'attrs': {
                        'name': '_tr-modal',
                        'appear': true
                    }
                }, [
                    h('div', {
                        'staticClass': '_dlg _con',
                        'class': {
                            '_dlgm': modal
                        },
                        'directives': [
                            {
                                name: 'show',
                                rawName: 'v-show',
                                value: this.visible,
                                expression: 'show'
                            }
                        ]
                    }, [
                        h('div', {
                            'staticClass': '_mdlg',
                            'attrs': {
                                'role': 'dialog',
                                'aria-modal': modal,
                                ...this.$attrs
                            }
                        }, [
                            this.$slots.default ? h('div', {
                                'staticClass': '_mdef'
                            }, this.$slots.default) : void 0,
                            this.$slots.buttons ? h('div', {
                                'staticClass': '_mbtn'
                            }, this.$slots.buttons) : void 0
                        ])
                    ])
                ]);
            }
        }
    }
</script>

<style lang="less">
    @import "../../less/globals.less";

    ._dlg {
        position: fixed;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: @z-dialog;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        pointer-events: none;
    }
    ._dlgm {
        pointer-events: all;
        /** Backdrop */
        &::before {
            content: '';
            position: fixed;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            background: #000;
            opacity: @modal-backdrop-opacity;
            pointer-events: none;
        }
    }
</style>
